<template>
  <v-autocomplete
    v-model="selected"
    :items="users"
    :label="label"
    :item-text="item => item.firstName + ' ' + item.lastName + ' <' + item.email + '>'"
    :item-value="item => '/users/' + item.id"
    :filter="customFilter"
    hide-no-data
    hide-selected
    prepend-icon="contacts"
    clearable
  >
    <template v-slot:item="{item}">
      <template>
        <v-list-item-avatar>
          <v-icon>account_box</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.firstName }} {{ item.lastName }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'UserSelector',
  props: {
    value: { required: true },
    users: { type: Array, required: true },
    label: { type: String, required: false, default: 'Users' }
  },
  data: () => ({
    search: null
  }),
  computed: {
    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    customFilter (item, queryText) {
      const searchText = queryText.toLowerCase()
      return item.firstName.toLowerCase().indexOf(searchText) > -1 ||
        item.lastName.toLowerCase().indexOf(searchText) > -1 || 
        item.email.indexOf(searchText) > -1 
    },
  }
}
</script>